import { slugs } from '@/constants/slugs'

export interface EarlyBirdValuesType {
  video?: string
  image?: string
  bgColor: string
  large: {
    classNames: string
    gradientWidth: string
    gradientHeight: string
    gradientPositionFromRight: string
    backgroundImage?: string
    image?: {
      src: string
      width: number
      height: number
    }
  }
  medium: {
    classNames: string
    gradientWidth: string
    gradientHeight: string
  }
  small: {
    classNames: string
    gradientWidth: string
    gradientHeight: string
  }
  experimentValues?: {
    video?: string
    image?: string
    bgColor?: string
  }
}

export const EarlyBirdValues: Record<string, EarlyBirdValuesType> = {
  [slugs.sketch]: {
    bgColor: 'bg-[#EAE0D9]',
    large: {
      classNames: 'z-[9] right-0',
      gradientWidth: '114px',
      gradientHeight: 'lg:!h-[140px] !h-[160px]',
      gradientPositionFromRight: '187px',
      backgroundImage: 'https://images.angelstudios.com/image/upload/v1749501666/sketch/bgpink.jpg',
      image: {
        src: '/v1749500634/sketch/iamge.png',
        width: 300,
        height: 140,
      },
    },
    medium: {
      classNames: 'z-9 right-0',
      gradientWidth: 'w-[254px]',
      gradientHeight: '!h-[160px]',
    },
    small: {
      classNames: 'z-9 right-0',
      gradientWidth: 'w-[270px]',
      gradientHeight: '!h-[160px]',
    },
    image:
      'https://images.angelstudios.com/image/upload/v1749500516/sketch/8b1795c517221c1ec1735503379a340404408e23.jpg',
    experimentValues: {
      video: 'https://images.angelstudios.com/video/upload/c_scale,h_453/v1744234819/tkok-popcorn-vid-01_vxdwcr.mp4',
      bgColor: '#EAE0D9',
    },
  },
}
